import React from 'react';
import { motion } from 'framer-motion';
export function SalesContent() {
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut'
      }
    }
  };
  return <div className="space-y-16 text-lg md:text-xl leading-relaxed text-[#1B2A4A]" data-id="element-186">
      {/* THE LEAD */}
      <motion.section initial="hidden" whileInView="visible" viewport={{
      once: true
    }} variants={fadeIn} className="space-y-6" data-id="element-187">
        <p data-id="element-188">
          It&apos;s the quiet realization that hits you about three months after
          that first direct deposit hits your account.
        </p>
        <p data-id="element-189">
          You look at the number. Then you look at the inflation at the grocery
          store. Then you look at the &quot;Delayed Credits&quot; chart one more
          time.
        </p>
        <p data-id="element-190">
          And the math finally sinks in: By claiming early, you just took a
          permanent 25% to 30% pay cut for the rest of your life.
        </p>
        <p className="font-medium" data-id="element-191">
          If you live to 85, that &quot;simple decision&quot; at age 62 just
          cost you and your wife over{' '}
          <span className="text-[#D4652A] font-bold text-2xl md:text-3xl align-middle mx-1" data-id="element-192">
            $150,000
          </span>{' '}
          in guaranteed, inflation-adjusted income.
        </p>
      </motion.section>

      {/* THE AGITATION */}
      <motion.section initial="hidden" whileInView="visible" viewport={{
      once: true
    }} variants={fadeIn} className="space-y-6" data-id="element-193">
        <p data-id="element-194">
          Most &quot;financial experts&quot; tell you it&apos;s too late. They
          say once you sign those papers at the SSA office, your fate is sealed.
          They tell you to just &quot;live within your means.&quot;
        </p>
        <p data-id="element-195">
          But they aren&apos;t the ones looking at a fixed check while property
          taxes and insurance premiums double. They aren&apos;t the ones worried
          about leaving their wife with a &quot;shrunken&quot; survivor benefit
          if they pass away first.
        </p>
      </motion.section>
    </div>;
}